import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Alert, Link, Text } from '@amzn/storm-ui';
import {
  selectSpoofingInfo,
  selectHeaderState,
  SpoofingInfo,
} from '../../store/slice';
import { RootState } from '../../../../app/store';
import { BoldText } from '../../../../commons/styles';

export const MobileSpoofingInfo: React.VFC<{
  spoofingInfo: SpoofingInfo;
  accountName?: string;
}> = ({ spoofingInfo, accountName }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Alert
      type="info"
      hideIcon={true}
      withCloseButton={true}
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div>
        <Text fontSize="small">
          {spoofingInfo.label && <BoldText>{spoofingInfo.label}: </BoldText>}
          {accountName}
        </Text>
      </div>
      <div>
        <Text fontSize="small">
          <Link
            href={spoofingInfo.quitButton.url}
            data-ccx-e2e-id="aac-quit-spoofing"
          >
            {spoofingInfo.quitButton.label}
          </Link>
        </Text>
      </div>
    </Alert>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    spoofingInfo: selectSpoofingInfo(state),
    accountName:
      selectHeaderState(state).currentAccountInfo?.currentAccountName,
  };
};

export default connect(mapStateToProps)(MobileSpoofingInfo);
